module.exports = __webpack_public_path__ + "img/Pixel8-logo-horizontal.52e8af0c.svg";